const ITEMS = ['STORIES', 'IDEAS', 'TECHNOLOGY', 'MUSIC', 'COSMIC BIOLOGY', 'THE PLACES THOUGHT CAN LEAD'];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="relative py-10 border-y border-cyan-500/10 overflow-hidden" data-testid="editorial-marquee">
      <div className="marquee-track flex whitespace-nowrap w-max">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className={`text-2xl sm:text-4xl tracking-wide px-6 ${i % 2 === 0 ? 'font-celestial text-slate-200/80' : 'font-mono-precision text-lg sm:text-2xl text-cyan-400/50 tracking-[0.3em]'}`}>
                  {item}
                </span>
                <span className="w-1.5 h-1.5 rounded-full bg-cyan-400/40" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
